<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_SUPPORT_PROG_ID'
        )
      }"
    >
      <select
        v-model="$parent.project.UF_SUPPORT_PROG_ID"
        v-on:change="$parent.$parent.updateAllSumPercent()"
        :disabled="
          $parent.project.CHANGE_PROGRAM_LIST.length === 0 ||
            $parent.$parent.projectDisabled
        "
        class="sel-dropdown i-main-style i-wid-29"
      >
        <option
          v-for="item in $parent.directory.program_fin_support"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
          v-if="
            inChangeProgramList(item.ID) ||
              $parent.project.UF_SUPPORT_PROG_ID === item.ID
          "
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_SUPPORT_PROG_ID"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_support_prog_id",
  methods: {
    inChangeProgramList(id) {
      let els = this.$parent.project.CHANGE_PROGRAM_LIST.filter(function(el) {
        if (el == id) {
          return true;
        }
        return false;
      }, this);
      return els.length > 0;
    }
  }
};
</script>

<style scoped></style>
